/** tel:-ссылка: цифры и плюс, как набирает телефон; без номера — null. */
export function telHref(raw: string | null | undefined): string | null {
  const n = raw?.replace(/[^\d+]/g, '') ?? '';
  return n.replace(/\D/g, '').length >= 5 ? `tel:${n}` : null;
}

export interface CallTarget {
  href: string;
  phone: string;
  /** Кому звоним — подпись у кнопки. */
  who: string;
}

/** Кому звонить из списка: владельцу (он решает про подписку), иначе в заведение. */
export function callTarget(r: {
  ownerName: string | null;
  ownerPhone: string | null;
  phone: string | null;
}): CallTarget | null {
  const owner = telHref(r.ownerPhone);
  if (owner && r.ownerPhone) return { href: owner, phone: r.ownerPhone, who: r.ownerName?.trim() || 'владелец' };
  const place = telHref(r.phone);
  if (place && r.phone) return { href: place, phone: r.phone, who: 'заведение' };
  return null;
}
